import { createUseStyles } from 'react-jss';
import { DESKTOP_FONT_SIZES, GLOBAL_LETTER_SPACING, MOBILE_FONT_SIZES, } from '@/styles/themes/components';
import { withAlpha } from '@/styles/utils';
export const useStyles = createUseStyles((theme) => ({
    field: {
        position: 'relative',
        height: 56,
        minHeight: 56,
        padding: 0,
        border: `1px solid ${theme.colors.textTertiary}`,
        borderRadius: 12,
        backgroundColor: theme.colors.field,
        color: theme.colors.sky,
        cursor: 'text',
        transition: 'none',
        outline: 0,
        '-webkit-tap-highlight-color': 'transparent',
        '&[data-active="true"]': {
            borderColor: theme.colors.brand,
        },
        '&[data-invalid="true"]': {
            borderColor: theme.colors.error,
        },
        [theme.breakpoints.up('sm')]: {
            height: 56,
            minHeight: 56,
        },
        [theme.breakpoints.up('lg')]: {
            height: 48,
            minHeight: 48,
        },
    },
    label: {
        position: 'absolute',
        left: 13,
        top: 12,
        fontSize: MOBILE_FONT_SIZES.small,
        lineHeight: 1,
        color: theme.colors.textPrimary,
        userSelect: 'none',
        pointerEvents: 'none',
        transition: theme.transition.global,
        '&[data-active="true"]': {
            color: theme.colors.brand,
        },
        '&[data-active="false"][data-hasvalue="false"]': {
            top: 18,
            fontSize: MOBILE_FONT_SIZES.input,
            lineHeight: 1.37,
            color: theme.colors.textSecondary,
        },
        [theme.breakpoints.up('sm')]: {
            left: 14,
        },
        [theme.breakpoints.up('lg')]: {
            top: 8,
            fontSize: DESKTOP_FONT_SIZES.small,
            '&[data-active="false"][data-hasvalue="false"]': {
                top: 14,
                fontSize: DESKTOP_FONT_SIZES.input,
            },
        },
    },
    input: {
        position: 'absolute',
        left: 13,
        top: 28,
        width: 'calc(var(--flight-mask-length, 10) * 1ch + 10px)',
        maxWidth: 'calc(100% - 67px)',
        height: 22,
        padding: 0,
        border: 0,
        outline: 0,
        appearance: 'none',
        background: 'transparent',
        color: theme.colors.sky,
        fontSize: '0.9375rem',
        lineHeight: 1.37,
        letterSpacing: '0.6px',
        fontFamily: 'inherit',
        fontWeight: 400,
        caretColor: theme.colors.sky,
        zIndex: 2,
        [theme.breakpoints.up('sm')]: {
            left: 14,
            letterSpacing: GLOBAL_LETTER_SPACING,
        },
        [theme.breakpoints.up('lg')]: {
            top: 20,
            fontSize: '0.875rem',
        },
        '&::placeholder': {
            color: theme.colors.textSecondary,
            opacity: 1,
        },
        '&::-webkit-input-placeholder': {
            color: theme.colors.textSecondary,
            opacity: 1,
        },
        '&::-moz-placeholder': {
            color: theme.colors.textSecondary,
            opacity: 1,
        },
        '&:-ms-input-placeholder': {
            color: theme.colors.textSecondary,
            opacity: 1,
        },
        '&::selection': {
            background: withAlpha(theme.colors.brand, theme.mode === 'light' ? 0.2 : 0.55),
            color: theme.mode === 'light'
                ? theme.colors.sky
                : theme.colors.white,
        },
    },
    postfixWrapper: {
        position: 'absolute',
        top: 0,
        right: 14,
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
}), { name: 'flight-masked-input' });
